import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../../models/dtos/error.dto';
import { Errors } from '../../../errors';


import getDocumentContractRepository , {ServiceResponse} from './getDocumentContract.repository';


type InitialState = {
  loading: boolean;
  data?: ServiceResponse[];
  error?: ErrorDto;
};

const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getDocumentContract = createAsyncThunk(
  'getDocumentContract',
  async (): Promise<ServiceResponse[]> => {
    return await getDocumentContractRepository().catch((error: any) => {
      throw error;
    });
  }
);

const serviceSlice = createSlice({
  name: 'getDocumentContract',
  initialState,
  reducers: {
    servicesReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDocumentContract.pending, (state) => {
      state.loading = true;
      state.data = [];
      state.error = undefined;
    });
    builder.addCase(
        getDocumentContract.fulfilled,
      (state, action: PayloadAction<ServiceResponse[]>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getDocumentContract.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default serviceSlice.reducer;
export const { servicesReset } = serviceSlice.actions;
